import React from 'react'
import { useController } from 'react-hook-form'
import "../pages/UtmVisualization/productSearch.css"

const SelectInput = ({ name, control, required, option = [] }) => {
    const {
        field,
        fieldState: { error }
    } = useController({
        name,
        control,
        rules: required ? { required: 'Field is required' } : undefined
    })

    return (
        <>
            <select {...field}
                className='form-input-field'
            >
                <option value="">Select an option</option>
                {option.map((curr, ind) => (
                    <option key={ind} value={curr}>
                        {curr}
                    </option>
                ))}
            </select>
            {error && <span style={{ color: 'red' }}>{error.message}</span>}
        </>
    )
}

export default SelectInput
